/** Saison courante cotisation membres — alignée sur le backend (DEFAULT_REGISTRATION_SEASON). */
export const MEMBERSHIP_SEASON = '2026-2027';
